/**
 * Google OAuth Configuration
 *
 * Shared configuration and utilities for Google OAuth.
 * Separated from component to allow fast refresh.
 *
 * Epic: E1.7 - Google OAuth Social Login Integration
 */

/**
 * Get Google Client ID from environment
 */
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || ''

/**
 * Check if Google OAuth is available/configured
 */
export function isGoogleOAuthAvailable(): boolean {
  return Boolean(GOOGLE_CLIENT_ID)
}

/**
 * Hook-style function to check if Google OAuth is available
 * (Not actually a hook, but named this way for component usage consistency)
 */
export function useGoogleOAuthAvailable(): boolean {
  return isGoogleOAuthAvailable()
}
